export default function initTogglesWithWrapper() {
  // The difference with initToggles is that this one works only inside a set wrapper
  const toggleGroups = document.querySelectorAll("[data-toggle-group]");

  if (!toggleGroups.length) {
    return;
  }

  toggleGroups.forEach((group) => {
    const toggles = group.querySelectorAll("[data-toggle-inner-element]");
    const targets = group.querySelectorAll("[data-toggle-inner-target]");

    function clearActives() {
      toggles.forEach((el) => {
        el.classList.remove("active");
      });
    }

    function clearWindows() {
      targets.forEach((el) => {
        el.classList.add("hidden");
      });
    }

    toggles.forEach((el) => {
      el.addEventListener("click", function () {
        clearActives();
        el.classList.toggle("active");

        const target = group.querySelector(
          `[data-toggle-inner-target=${el.dataset.toggleInnerElement}]`
        );

        if (!target.classList.contains("hidden")) {
          clearActives();
          target.classList.add("hidden");
        } else {
          clearWindows();
          target.classList.remove("hidden");
        }
      });
    });

    // Add event listener for the 'Escape' key within the group
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        clearWindows();
        clearActives();
      }
    });
  });
}
